import React, { FC, SVGProps } from 'react'

import ICONS from './components/Icons'

type PaymentIconProps = SVGProps<SVGSVGElement> & {
  type: string
}

const PaymentIcon: FC<PaymentIconProps> = ({ type, ...rest }) => {
  const PaymentIcon = ICONS[type]
  return PaymentIcon ? <PaymentIcon {...rest} /> : null
}

export default PaymentIcon
